// Keep the vendor queue immediate; defer its network fan-out until the PDP image paints.
(() => {
  const productPage = document.currentScript?.dataset.productPage === 'true';
  const url = 'https://static.klaviyo.com/onsite/js/Xyjw5H/klaviyo.js?company_id=Xyjw5H';
  let started = false;
  let fallback;
  const intentEvents = ['pointerdown', 'keydown', 'focusin'];
  const load = () => {
    if (started) return;
    started = true;
    clearTimeout(fallback);
    intentEvents.forEach((name) => document.removeEventListener(name, load, true));
    // Never add a second vendor loader if another integration already supplied it.
    if (window.__jsocKlaviyoLoaderRequested || document.querySelector('script[src*="static.klaviyo.com/onsite/js/"]')) return;
    window.__jsocKlaviyoLoaderRequested = true;
    const script = document.createElement('script');
    script.async = true;
    script.src = url;
    script.dataset.jsocKlaviyo = 'true';
    document.head.appendChild(script);
  };
  if (!productPage) { load(); return; }
  intentEvents.forEach((name) => document.addEventListener(name, load, true));
  fallback = setTimeout(load, 6000);
  const image = document.querySelector('media-gallery .product__media img[fetchpriority="high"]');
  const afterPaint = () => requestAnimationFrame(() => requestAnimationFrame(load));
  const afterDecode = () => image.decode ? image.decode().then(afterPaint, afterPaint) : afterPaint();
  if (!image) { load(); return; }
  if (image.complete && image.naturalWidth) {
    afterDecode();
  } else {
    image.addEventListener('load', afterDecode, { once: true });
    image.addEventListener('error', load, { once: true });
  }
})();
